import React from 'react';

const WaybillExceptionTableComponentLoadable = React.lazy(() => import('./ExceptionTab'));

export {
    WaybillExceptionTableComponentLoadable
}